import css from "styled-jsx/css";
import { grid } from "../constants";

export default css`
.streaming-carousel {
  padding-top: 1.25rem;
  padding-bottom: 2rem;
}
.streaming-carousel :global(.carousel) {
  padding: 0;
}
.streaming-carousel :global(.carousel) :global(.carousel-window) {
  gap: 0.5rem !important;
}

@media screen and (min-width: ${grid.breakpoint_sm}px) {
  .streaming-carousel {
    padding-top: 2rem;
  }
  .streaming-carousel :global(.carousel) :global(.carousel-window) {
    gap: 1rem !important;
  }
}
@media screen and (min-width: ${grid.breakpoint_md}px) {
  .streaming-carousel {
    padding-top: 2.5rem;
    padding-bottom: 1.25rem;
    gap: 1.5rem !important;
  }
}
`;
